/**
 * How a page's actions show on a narrow screen (its header's, its toolbars'): by their icons alone, their words for
 * screen readers (as the iOS app's bar), or with their words too. Kept on this device (a trial of either: docs/ICONS.md),
 * marked on the root (`data-bar-labels`) for the `bar-icons` variant (app.css).
 */
import { store, stored } from "./storage.ts";

const KEY = "revisa.barLabels";

/** Whether actions show their words on a narrow screen too. */
export function barLabels(): boolean {
  return stored(KEY) === "1";
}

/** Shows them (`on`) or not, and keeps it. */
export function setBarLabels(on: boolean): void {
  store(KEY, on ? "1" : null);
  markBarLabels();
}

/** The root marked as kept. */
export function markBarLabels(): void {
  document.documentElement.toggleAttribute("data-bar-labels", barLabels());
}
